import ExpandableContent from 'Component/ExpandableContent';
import {
    MyAccountTabList as SourceMyAccountTabList
} from 'SourceComponent/MyAccountTabList/MyAccountTabList.component';

import './MyAccountTabList.override.style';

/** @namespace PeggysagePwa/Component/MyAccountTabList/Component */
export class MyAccountTabListComponent extends SourceMyAccountTabList {
    /**
     * Override: handle groups of items
     * @param tabEntry
     * @param index
     * @param tabArray
     * @param level
     * @returns {JSX.Element|null|*}
     */
    renderTabListItem(tabEntry, index, tabArray, level = 0) {
        const { tabMap } = this.props;
        const [key, tab] = tabEntry;
        const { tabName, parent, hasChildren } = tab;

        if (parent && level === 0) {
            return null;
        }

        if (hasChildren) {
            const tabs = Object.entries(tabMap)
                .filter(([, item]) => item.parent === key)
                .map((tabEntry, index, tabArray) => (
                    this.renderTabListItem(tabEntry, index, tabArray, level + 1)
                ));

            return (
                <li block="MyAccountTabListItem" mods={ { isGroup: true } } key={ key }>
                    <ExpandableContent
                      heading={ tabName }
                      isContentExpanded
                      mix={ { block: 'MyAccountTabListItem', elem: 'Group', className: key } }
                      mods={ { isWithoutBorder: true } }
                    >
                        <ul>
                            { tabs }
                        </ul>
                    </ExpandableContent>
                </li>
            );
        }

        return super.renderTabListItem(tabEntry, index, tabArray);
    }

    /**
     * Override: remove line
     * @returns {null}
     */
    renderLine() {
        return null;
    }

    /**
     * Override: add classname on button
     * @returns {JSX.Element}
     */
    renderLogoutTab() {
        const { handleLogout } = this.props;

        return (
            <li
              key="logout"
              block="MyAccountTabListItem"
            >
                <button
                  block="MyAccountTabListItem"
                  elem="Button"
                  onClick={ handleLogout }
                  role="link"
                  className="logout"
                >
                    { __('Logout') }
                </button>
            </li>
        );
    }

    /**
     * Override: remove ExpandableContent
     * @returns {JSX.Element}
     */
    render() {
        const { tabMap } = this.props;

        const tabs = [
            ...Object.entries(tabMap).map(this.renderTabListItem.bind(this)),
            this.renderLogoutTab()
        ];

        return (
            <div block="MyAccountTabList">
                <ul>
                    { tabs }
                </ul>
            </div>
        );
    }
}

export default MyAccountTabListComponent;
